<div id="serviceElements" class="btn btn-light btn-rounded btn-md text-uppercase align-self-center form-fields-btn"
  (click)="openComponentsModal()">
  {{'Show reusable blocks' | translate}}
</div>
